
export default class Item {

  public title: string;
  public buttonName: string;
  public buttonLink: string;

//   <ContactRow name={"John Smith"} title={"Title"} email={"john.smith@dynatrace.com"} phoneNumber={"Tel. +1 630-886-9981"} image={matt_howard} />
  constructor(title: string, buttonName: string, buttonLink: string) {
    // this.name = name;
    this.title = title;
    this.buttonName = buttonName;
    this.buttonLink = buttonLink;
  }

}
